/* ta-swatch-card: animated paint swatch product card (Tri-Art)
   One shared brush texture is generated per page (after load, when the browser is idle)
   and reused by every card. Motion only runs on the card under the cursor, or on cards
   in view while scrolling on touch devices. Respects prefers-reduced-motion. */
(function () {
  if (window.customElements && customElements.get('ta-swatch-card')) return;

  var OP = { T: .8, ST: .6, SO: .3, O: .06 };
  var SH = {
    G:  { spec: 1,   lr: '38%', tex: 'gloss', shade: 1,   gl: 0 },
    SG: { spec: .6,  lr: '44%', tex: 'soft',  shade: .85, gl: 0 },
    M:  { spec: .14, lr: '75%', tex: 'soft',  shade: .7,  gl: 0 },
    MET:{ spec: .75, lr: '46%', tex: 'sharp', shade: .9,  gl: .95 }
  };
  function key(v) { return String(v || '').toLowerCase().replace(/[^a-z]/g, ''); }
  function normOp(v) { return { t:'T', transparent:'T', st:'ST', semitransparent:'ST', so:'SO', semiopaque:'SO', o:'O', opaque:'O' }[key(v)] || 'SO'; }
  function normSh(v) { return { g:'G', gloss:'G', glossy:'G', sg:'SG', semigloss:'SG', m:'M', matte:'M', matt:'M' }[key(v)] || 'SG'; }

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noHover = matchMedia('(hover: none)').matches;

  /* ---------- shared procedural brushwork ---------- */
  var TEX = { small: null, large: null, smallF: null, largeF: null, smallI: null, largeI: null, smallD: null, largeD: null }, waiting = { small: [], large: [], smallF: [], largeF: [], smallI: [], largeI: [], smallD: [], largeD: [] };
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function blur(src, w, h, n) { var a = src, b = new Float32Array(w * h);
    for (var k = 0; k < n; k++) { for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { var s = 0, c = 0;
      for (var dy = -1; dy <= 1; dy++) { var yy = y + dy; if (yy < 0 || yy >= h) continue;
        for (var dx = -1; dx <= 1; dx++) { var xx = x + dx; if (xx < 0 || xx >= w) continue; s += a[yy * w + xx]; c++; } }
      b[y * w + x] = s / c; } var t = a; a = b; b = (t === src) ? new Float32Array(w * h) : t; }
    return a; }
  function newCanvas(S) {
    if (typeof document === 'undefined') return new OffscreenCanvas(S, S);
    var c = document.createElement('canvas'); c.width = c.height = S; return c;
  }
  function toURL(data, S) { var c = newCanvas(S), x = c.getContext('2d');
    var im = x.createImageData(S, S); im.data.set(data); x.putImageData(im, 0, 0); return 'url(' + c.toDataURL('image/png') + ')'; }

  /* thickness (0..1 per pixel) -> alpha mask used by the masstone layer */
  function depthURL(Tk, S) {
    var d = new Uint8ClampedArray(S * S * 4);
    for (var i = 0; i < S * S; i++) { var o = i * 4; d[o] = d[o + 1] = d[o + 2] = 255; d[o + 3] = Math.max(0, Math.min(1, Tk[i])) * 255; }
    return toURL(d, S);
  }
  function makeTexture(seed, S) {
    var R = rng(seed), c = newCanvas(S), g = c.getContext('2d');
    g.fillStyle = '#808080'; g.fillRect(0, 0, S, S); g.lineCap = 'round';
    for (var j = 0; j < 14; j++) { var gx = R() * S, gy = R() * S, gr = S * (.1 + R() * .2), gv = R() < .5 ? 90 : 170, rg = g.createRadialGradient(gx, gy, 0, gx, gy, gr);
      rg.addColorStop(0, 'rgba(' + gv + ',' + gv + ',' + gv + ',.35)'); rg.addColorStop(1, 'rgba(' + gv + ',' + gv + ',' + gv + ',0)'); g.fillStyle = rg; g.fillRect(0, 0, S, S); }
    for (var i = 0; i < 70; i++) {
      var y0 = R() * S, x0 = R() * S * 1.2 - S * .3, len = S * (.45 + R() * .6), ang = (R() - .5) * .22, wid = S * (.1 + R() * .14), n = 22 + (R() * 18 | 0), bend = (R() - .5) * wid * .9;
      var ca = Math.cos(ang), sa = Math.sin(ang), base = R() < .5 ? -1 : 1;
      for (var b = 0; b < n; b++) { var off = (b / n - .5) * wid + (R() - .5) * 2, L = len * (.8 + R() * .2), v = 128 + base * 18 + (R() - .5) * 120;
        g.strokeStyle = 'rgba(' + (v | 0) + ',' + (v | 0) + ',' + (v | 0) + ',' + (.05 + R() * .1).toFixed(2) + ')'; g.lineWidth = .6 + R() * 1.6;
        var sx = x0 - sa * off + R() * 8, sy = y0 + ca * off; g.beginPath(); g.moveTo(sx, sy);
        g.quadraticCurveTo(sx + ca * L * .5 - sa * bend, sy + sa * L * .5 + ca * bend, sx + ca * L, sy + sa * L); g.stroke(); }
      g.strokeStyle = 'rgba(215,215,215,.16)'; g.lineWidth = 2 + R() * 3;
      for (var e = -1; e <= 1; e += 2) { var ox = -sa * e * wid * .5, oy = ca * e * wid * .5; g.beginPath(); g.moveTo(x0 + ox, y0 + oy);
        g.quadraticCurveTo(x0 + ox + ca * len * .5 - sa * bend, y0 + oy + sa * len * .5 + ca * bend, x0 + ox + ca * len, y0 + oy + sa * len); g.stroke(); }
    }
    var px = g.getImageData(0, 0, S, S).data, H = new Float32Array(S * S); for (var p = 0; p < S * S; p++) H[p] = px[p * 4];
    H = blur(H, S, S, 1);
    var lo = 1e9, hi = -1e9; for (var z = 0; z < S * S; z++) { if (H[z] < lo) lo = H[z]; if (H[z] > hi) hi = H[z]; }
    var TK = new Float32Array(S * S), Hs = blur(H, S, S, 2);
    /* impasto thickness varies on two scales: broad loaded and dragged-out areas (where the brush was
       full vs running dry, and heavier toward the start of each stroke), plus the ridges within them */
    var ld = vnoise(seed + 61), ld2 = vnoise(seed + 83), sc2 = S / 320;
    for (z = 0; z < S * S; z++) { var zx = (z % S) / sc2, zy = (z / S | 0) / sc2;
      var load = ld(zx / 70, zy / 45) * .65 + ld2(zx / 28, zy / 60) * .35;             /* broad patches */
      load = Math.max(0, Math.min(1, (load - .32) * 2.1)) * (1 - .35 * (zx / 320));    /* thicker toward where strokes start */
      var ridge = Math.pow((Hs[z] - lo) / Math.max(1, hi - lo), 1.4);
      TK[z] = Math.min(1, .08 + .62 * load + .45 * ridge * (.4 + .6 * load)); }
    var shade = new Uint8ClampedArray(S * S * 4), sp = new Float32Array(S * S);
    for (var y = 1; y < S - 1; y++) for (var x = 1; x < S - 1; x++) { var k = y * S + x, s = (H[k - S - 1] - H[k + S + 1] + (H[k - 1] - H[k + 1]) * .5) * (S / 320); /* keep relief the same at any texture size */
      var vv = 128 + s * 1.7; shade[k * 4] = shade[k * 4 + 1] = shade[k * 4 + 2] = vv; shade[k * 4 + 3] = 255; sp[k] = Math.max(0, s - 2); }
    var sharp = new Uint8ClampedArray(S * S * 4), soft = new Uint8ClampedArray(S * S * 4), gloss = new Uint8ClampedArray(S * S * 4), spS = blur(sp, S, S, 2);
    for (var q = 0; q < S * S; q++) { sharp[q * 4] = sharp[q * 4 + 1] = sharp[q * 4 + 2] = 255; sharp[q * 4 + 3] = Math.min(255, sp[q] * 22);
      soft[q * 4] = soft[q * 4 + 1] = soft[q * 4 + 2] = 255; soft[q * 4 + 3] = Math.min(255, spS[q] * 12);
      /* gloss: wet-look ridges, brighter and tighter, with a soft halo around each */
      gloss[q * 4] = gloss[q * 4 + 1] = gloss[q * 4 + 2] = 255; gloss[q * 4 + 3] = Math.min(255, sp[q] * 40 + spS[q] * 10); }
    var M = new Uint8ClampedArray(S * S * 4), ins = S * .09, st = 0, stv = 0, top = [], bot = [], t1 = R() * 9, t2 = R() * 9;
    for (var xx = 0; xx < S; xx++) { top[xx] = ins + Math.sin(xx * .021 + t1) * 3 + Math.sin(xx * .07 + t2) * 1.6 + (R() - .5) * 1.4;
      bot[xx] = S - ins + Math.sin(xx * .017 + t2) * 3 + Math.sin(xx * .06 + t1) * 1.6 + (R() - .5) * 1.4; }
    for (var yy = 0; yy < S; yy++) { if (st-- <= 0) { st = 1 + (R() * 4 | 0); stv = R(); }
      var Lx = ins + (stv * stv) * S * .05 + (R() - .5) * 1.5, Rx = S - ins - (R() * R()) * S * .035 + Math.sin(yy * .05) * 2;
      for (var x2 = 0; x2 < S; x2++) { var a = 1;
        if (x2 < Lx) a = Math.max(0, 1 - (Lx - x2) / 3); if (x2 > Rx) a = Math.min(a, Math.max(0, 1 - (x2 - Rx) / (2 + stv * 7)));
        if (yy < top[x2]) a = Math.min(a, Math.max(0, 1 - (top[x2] - yy) / 2)); if (yy > bot[x2]) a = Math.min(a, Math.max(0, 1 - (yy - bot[x2]) / 2));
        var m = (yy * S + x2) * 4; M[m] = M[m + 1] = M[m + 2] = 255; M[m + 3] = a * 255; } }
    return { shade: toURL(shade, S), sharp: toURL(sharp, S), soft: toURL(soft, S), gloss: toURL(gloss, S), mask: toURL(M, S), depth: depthURL(TK, S) };
  }

  /* Liquid acrylic ("lotion" consistency): a few broad, self-levelling strokes with soft rounded
     ends, a slightly raised bead along each edge where the paint pools, faint drag lines and no
     impasto. Returns the same layers as makeTexture so the card renders it the same way. */
  function makeFluid(seed, S) {
    var R = rng(seed + 300), N = S * S, H = new Float32Array(N), M = new Float32Array(N), sc = S / 320, nz = vnoise(seed + 11), nz2 = vnoise(seed + 29);
    var bands = [], nb = 3, y0 = S * .12, y1 = S * .88, bh = (y1 - y0) / nb;
    for (var b = 0; b < nb; b++) bands.push({ yc: y0 + bh * (b + .5) + (R() - .5) * bh * .15, hw: bh * (.62 + R() * .1),
      xa: S * (.08 + R() * .05), xb: S * (.9 - R() * .06), ra: S * (.05 + R() * .04), rb: S * (.06 + R() * .05), ph: R() * 40, tilt: (R() - .5) * .05 });
    for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) { var i = y * S + x, u = x / sc, v = y / sc, h = 0, m = 0;
      for (var k = 0; k < nb; k++) { var B = bands[k], yc = B.yc + (x - S / 2) * B.tilt + (nz(u / 70 + B.ph, 3.1) - .5) * 10 * sc, hw = B.hw * (.92 + .16 * nz(u / 45 + B.ph, 7.7));
        var dy = Math.abs(y - yc) / hw, lim = 1;
        if (x < B.xa) { var ex = (B.xa - x) / B.ra; lim = ex >= 1 ? 0 : Math.sqrt(1 - ex * ex); }       /* rounded start */
        else if (x > B.xb) { var ex2 = (x - B.xb) / B.rb; lim = ex2 >= 1 ? 0 : Math.sqrt(1 - ex2 * ex2); } /* rounded end */
        if (dy < lim) { var t = dy / Math.max(lim, .001), edge = Math.max(0, lim - dy) * hw / sc;
          var bead = Math.exp(-Math.pow((t - .82) / .12, 2)) * .9;                     /* paint pooled along the edge */
          var hh = .35 * (1 - t * t) + bead + .06 * Math.sin(u / 9 + B.ph + v / 31) + .05 * (nz2(u / 1.8, v / 14) - .5);   /* gentle swell, drag lines */
          h = Math.max(h, hh); m = Math.max(m, Math.min(1, edge / 1.4)); } }
      H[i] = h * 90; M[i] = m; }
    H = boxBlur(H, S, S, Math.max(1, Math.round(1.6 * sc)));                         /* self-levelling */
    var TK = new Float32Array(N); for (var z = 0; z < N; z++) TK[z] = M[z] * Math.min(1, .15 + H[z] / 90 * .95);
    var shade = new Uint8ClampedArray(N * 4), sp = new Float32Array(N);
    for (y = 1; y < S - 1; y++) for (x = 1; x < S - 1; x++) { var q = y * S + x, s = (H[q - S - 1] - H[q + S + 1] + (H[q - 1] - H[q + 1]) * .5) * (1 / sc);
      var vv = 128 + s * 1.5; shade[q * 4] = shade[q * 4 + 1] = shade[q * 4 + 2] = vv; shade[q * 4 + 3] = 255; sp[q] = Math.max(0, s - 1.2); }
    var sharp = new Uint8ClampedArray(N * 4), soft = new Uint8ClampedArray(N * 4), gloss = new Uint8ClampedArray(N * 4), spS = boxBlur(sp, S, S, 2), mask = new Uint8ClampedArray(N * 4);
    for (var o = 0; o < N; o++) { var o4 = o * 4;
      sharp[o4] = sharp[o4 + 1] = sharp[o4 + 2] = 255; sharp[o4 + 3] = Math.min(255, sp[o] * 26);
      soft[o4] = soft[o4 + 1] = soft[o4 + 2] = 255; soft[o4 + 3] = Math.min(255, spS[o] * 16);
      gloss[o4] = gloss[o4 + 1] = gloss[o4 + 2] = 255; gloss[o4 + 3] = Math.min(255, sp[o] * 46 + spS[o] * 14);
      mask[o4] = mask[o4 + 1] = mask[o4 + 2] = 255; mask[o4 + 3] = M[o] * 255; }
    return { shade: toURL(shade, S), sharp: toURL(sharp, S), soft: toURL(soft, S), gloss: toURL(gloss, S), mask: toURL(mask, S), depth: depthURL(TK, S) };
  }

  /* Low Viscosity ("ink" consistency): a flat, self-levelled pour with a thin meniscus at the edge,
     pigment pooling darker along the rim, runs dripping off the bottom edge and a few splashes.
     No brush ridges at all. Same output layers as makeTexture. */
  function makeInk(seed, S) {
    var R = rng(seed + 700), N = S * S, M = new Float32Array(N), sc = S / 320, nz = vnoise(seed + 5), x, y, i;
    var top = .3 * S + (R() - .5) * S * .04, bot = .64 * S + (R() - .5) * S * .04, xa = S * (.07 + R() * .04), xb = S * (.93 - R() * .04), ph = R() * 50;
    var drips = [], nd = 3 + (R() * 3 | 0);
    for (var d = 0; d < nd; d++) drips.push({ x: xa + (xb - xa) * (.1 + .8 * (d + R() * .6) / nd), w: (3 + R() * 4) * sc, L: (25 + R() * 85) * sc });
    var drops = []; for (var k = 0; k < 9; k++) drops.push({ x: R() * S, y: R() < .5 ? top - (6 + R() * 30) * sc : bot + (8 + R() * 40) * sc, r: (1.2 + R() * 3.2) * sc });
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) { i = y * S + x; var u = x / sc, m = 0;
      var t = top + (nz(u / 60 + ph, 1.3) - .5) * 14 * sc, b = bot + (nz(u / 50 + ph, 4.1) - .5) * 16 * sc;
      var ra = (b - t) / 2, cyy = (t + b) / 2;
      if (x >= xa && x <= xb && y > t && y < b) m = 1;
      else if (x < xa || x > xb) { var ex = x < xa ? (xa - x) : (x - xb), ey = Math.abs(y - cyy); if (ex * ex / (ra * .55 * ra * .55) + ey * ey / (ra * ra) < 1) m = 1; }  /* rounded ends */
      for (var q = 0; q < drips.length && !m; q++) { var D = drips[q], dx = Math.abs(x - D.x), yb = b - 2 * sc;
        if (y > yb && y < yb + D.L && dx < D.w * (1 - .35 * (y - yb) / D.L)) m = 1;                                             /* run */
        var ey2 = y - (yb + D.L); if (dx * dx + ey2 * ey2 < D.w * D.w * 1.1) m = 1; }                                             /* bead at the end */
      for (q = 0; q < drops.length && !m; q++) { var P = drops[q]; if ((x - P.x) * (x - P.x) + (y - P.y) * (y - P.y) < P.r * P.r) m = 1; }
      M[i] = m; }
    var Ms = boxBlur(M, S, S, Math.max(1, Math.round(.8 * sc))), Hh = boxBlur(M, S, S, Math.max(2, Math.round(3.5 * sc))), Rim = boxBlur(M, S, S, Math.max(2, Math.round(5 * sc)));
    var shade = new Uint8ClampedArray(N * 4), sp = new Float32Array(N);
    for (y = 1; y < S - 1; y++) for (x = 1; x < S - 1; x++) { i = y * S + x;
      var s = (Hh[i - S - 1] - Hh[i + S + 1] + (Hh[i - 1] - Hh[i + 1]) * .5) * 60 / sc;            /* meniscus only: flat inside */
      var rim = Math.max(0, Ms[i] - Rim[i]) * 70, streak = (nz(x / sc / 3, y / sc / 40) - .5) * 5;  /* pooled edge, faint flow streaks */
      var vv = 128 + s * .8 - rim + streak; shade[i * 4] = shade[i * 4 + 1] = shade[i * 4 + 2] = vv; shade[i * 4 + 3] = 255; sp[i] = Math.max(0, s - .6); }
    var sharp = new Uint8ClampedArray(N * 4), soft = new Uint8ClampedArray(N * 4), gloss = new Uint8ClampedArray(N * 4), spS = boxBlur(sp, S, S, 3), mask = new Uint8ClampedArray(N * 4);
    var TK = new Float32Array(N); for (i = 0; i < N; i++) TK[i] = Ms[i] * Math.min(1, .12 + Math.max(0, Ms[i] - Rim[i]) * 2.2 + Math.max(0, Hh[i] - .85) * 2);
    for (i = 0; i < N; i++) { var o = i * 4;
      sharp[o] = sharp[o + 1] = sharp[o + 2] = 255; sharp[o + 3] = Math.min(255, sp[i] * 30);
      soft[o] = soft[o + 1] = soft[o + 2] = 255; soft[o + 3] = Math.min(255, spS[i] * 22);
      gloss[o] = gloss[o + 1] = gloss[o + 2] = 255; gloss[o + 3] = Math.min(255, sp[i] * 55 + spS[i] * 18);
      mask[o] = mask[o + 1] = mask[o + 2] = 255; mask[o + 3] = Ms[i] * 255; }
    return { shade: toURL(shade, S), sharp: toURL(sharp, S), soft: toURL(soft, S), gloss: toURL(gloss, S), mask: toURL(mask, S), depth: depthURL(TK, S) };
  }

  /* Art Noise (acrylic gouache): flat, opaque, ultra-matte paint dripping down from the top edge,
     echoing the drips on the Art Noise label. Chalky surface grain, no gloss. */
  function makeDrip(seed, S) {
    var R = rng(seed + 900), N = S * S, M = new Float32Array(N), sc = S / 320, nz = vnoise(seed + 17), x, y, i;
    var base = S * (.27 + R() * .04), drips = [], n = 6 + (R() * 3 | 0);
    for (var d = 0; d < n; d++) { var w = (7 + R() * 10) * sc;
      drips.push({ x: S * (.08 + .84 * (d + .2 + R() * .6) / n), w: w, L: S * (.08 + R() * .38), r: w * (1.05 + R() * .3) }); }
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) { i = y * S + x; var u = x / sc, m = 0;
      var edge = base + (nz(u / 40, 2.2) - .5) * 22 * sc + (nz(u / 11, 5.5) - .5) * 5 * sc;
      if (y < edge) m = 1;
      for (var q = 0; q < n && !m; q++) { var D = drips[q], dx = x - D.x, yy = y - edge;
        if (yy >= -2 && yy < D.L) { var t = yy / D.L, fil = D.w * (1 + 1.6 * Math.max(0, 1 - yy / (D.w * 2.2)));   /* flared where it leaves the edge */
          if (Math.abs(dx) < Math.max(D.w * (1 - .25 * t), fil * .5 + D.w * .5 * (1 - Math.min(1, yy / (D.w * 2.2))))) m = 1; }
        var ey = y - (edge + D.L); if (dx * dx + ey * ey < D.r * D.r) m = 1; }                      /* round drop at the end */
      M[i] = m; }
    var Ms = boxBlur(M, S, S, Math.max(1, Math.round(.8 * sc))), Hh = boxBlur(M, S, S, Math.max(2, Math.round(3 * sc)));
    var shade = new Uint8ClampedArray(N * 4), none = new Uint8ClampedArray(N * 4), mask = new Uint8ClampedArray(N * 4);
    for (y = 1; y < S - 1; y++) for (x = 1; x < S - 1; x++) { i = y * S + x;
      var s = (Hh[i - S - 1] - Hh[i + S + 1] + (Hh[i - 1] - Hh[i + 1]) * .5) * 45 / sc, grain = (nz(x / sc / 1.3, y / sc / 1.3) - .5) * 16;
      var vv = 128 + s + grain; shade[i * 4] = shade[i * 4 + 1] = shade[i * 4 + 2] = vv; shade[i * 4 + 3] = 255; }
    for (i = 0; i < N; i++) { var o = i * 4; none[o] = none[o + 1] = none[o + 2] = 255; none[o + 3] = 0;
      mask[o] = mask[o + 1] = mask[o + 2] = 255; mask[o + 3] = Ms[i] * 255; }
    var blank = toURL(none, S), TK = new Float32Array(N);
    for (i = 0; i < N; i++) TK[i] = Ms[i] * (.3 + .7 * Math.pow(Hh[i], 1.5));
    return { shade: toURL(shade, S), sharp: blank, soft: blank, gloss: blank, mask: toURL(mask, S), depth: depthURL(TK, S) };
  }

  var FLAKE = null;
  function makeFlake() {
    var S = 150, R = rng(91), c = newCanvas(S), g = c.getContext('2d');
    for (var i = 0; i < 520; i++) { var x = R() * S, y = R() * S, big = R() < .12, a = .25 + R() * .75;
      g.fillStyle = 'rgba(255,255,255,' + a.toFixed(2) + ')';
      if (big) { g.fillRect(x, y, 2, 2); g.fillStyle = 'rgba(255,255,255,' + (a * .35).toFixed(2) + ')'; g.fillRect(x - 1, y + .5, 4, 1); g.fillRect(x + .5, y - 1, 1, 4); }
      else g.fillRect(x, y, 1, 1); }
    return toURL(g.getImageData(0, 0, S, S).data, S);
  }
  /* primed canvas weave (light and black gesso), shared per page */
  var CANVAS = { small: null, large: null };
  function makeCanvas(S) {
    var N = S * S, p = 3.3 * (S / 360), nz = vnoise(91), nz2 = vnoise(57), H = new Float32Array(N), x, y, i;
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) {
      var u = x / p, v = y / p, cx = Math.floor(u), cy = Math.floor(v), fx = u - cx, fy = v - cy;
      var warp = Math.sin(Math.PI * fx) * (.82 + .36 * nz(cx * .9, v / 7)), weft = Math.sin(Math.PI * fy) * (.82 + .36 * nz(u / 7, cy * .9 + 40));
      H[y * S + x] = ((cx + cy) & 1 ? warp * (.75 + .25 * Math.sin(Math.PI * fy)) : weft * (.75 + .25 * Math.sin(Math.PI * fx))) + (nz2(u / 9, v / 9) - .5) * .25;
    }
    var B = boxBlur(H, S, S, 1), light = new Uint8ClampedArray(N * 4), dark = new Uint8ClampedArray(N * 4);
    for (i = 0; i < N; i++) H[i] = H[i] * .55 + B[i] * .45;   /* gesso partly fills the weave */
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) { i = y * S + x; var o = i * 4;
      var sh = (y > 0 && x > 0 && y < S - 1 && x < S - 1) ? (H[i - S - 1] - H[i + S + 1]) : 0, m = (nz2(x / 40, y / 40) - .5) * 6;
      light[o] = 242 + sh * 34 + m; light[o + 1] = 239 + sh * 34 + m; light[o + 2] = 231 + sh * 32 + m; light[o + 3] = 255;
      dark[o] = 31 + sh * 20 + m * .5; dark[o + 1] = 30 + sh * 20 + m * .5; dark[o + 2] = 29 + sh * 19 + m * .5; dark[o + 3] = 255; }
    return { light: toURL(light, S), dark: toURL(dark, S) };
  }
  /* small: 3 variants at 320px for grids. large: 1 variant at 640px for the product page */
  var PLAN = { small: { seeds: [7, 19, 42], S: 320 }, large: { seeds: [7], S: 640 } };
  function buildTextures(key) {
    var size = key.indexOf('large') === 0 ? 'large' : 'small', kind = { F: 'fluid', I: 'ink', D: 'drip' }[key.slice(-1)] || 'acrylic', plan = PLAN[size], CS = size === 'large' ? 720 : 360;
    runJob({ kind: kind, seeds: plan.seeds, S: plan.S, CS: CS }, function (out) {
      TEX[key] = out.tex; if (!CANVAS[size]) CANVAS[size] = out.canvas; if (!FLAKE) FLAKE = out.flake;
      waiting[key].splice(0).forEach(function (el) { el.texture(); });
    });
  }

  /* ---------- texture generation off the main thread ----------
     The brushwork, canvas weave, watercolour paper and wash are all computed in a Web Worker
     (with OffscreenCanvas), so scrolling stays smooth while they are made on first load.
     Browsers without OffscreenCanvas fall back to building them on the page in idle time. */
  var worker = null, jobs = {}, jobSeq = 0;
  function computeJob(job) {
    if (job.kind === 'acrylic') return { tex: job.seeds.map(function (s) { return makeTexture(s, job.S); }), canvas: makeCanvas(job.CS), flake: makeFlake() };
    if (job.kind === 'fluid') return { tex: job.seeds.map(function (s) { return makeFluid(s, job.S); }), canvas: makeCanvas(job.CS), flake: makeFlake() };
    if (job.kind === 'ink') return { tex: job.seeds.map(function (s) { return makeInk(s, job.S); }), canvas: makeCanvas(job.CS), flake: makeFlake() };
    if (job.kind === 'drip') return { tex: job.seeds.map(function (s) { return makeDrip(s, job.S); }), canvas: makeCanvas(job.CS), flake: makeFlake() };
    return { wash: makeWash(job.seed, job.S), flake: makeFlake() };
  }
  function getWorker() {
    if (worker !== null) return worker;
    try {
      if (typeof OffscreenCanvas === 'undefined' || !OffscreenCanvas.prototype.convertToBlob || typeof Worker === 'undefined') throw 0;
      var src = [rng, blur, newCanvas, makeTexture, makeFluid, makeInk, makeDrip, makeFlake, vnoise, boxBlur, makeCanvas, makeWash, computeJob].map(String).join('\n') +
        '\nvar pending=[];function toURL(d,S){pending.push({d:d,S:S});return "@@"+(pending.length-1);}' +
        '\nonmessage=function(e){var job=e.data;try{pending=[];var out=computeJob(job);' +
        'Promise.all(pending.map(function(p){var c=new OffscreenCanvas(p.S,p.S);c.getContext("2d").putImageData(new ImageData(p.d,p.S,p.S),0,0);return c.convertToBlob({type:"image/png"});}))' +
        '.then(function(b){postMessage({id:job.id,out:out,blobs:b});},function(err){postMessage({id:job.id,error:String(err)});});' +
        '}catch(err){postMessage({id:job.id,error:String(err)});}};';
      worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
      worker.onmessage = function (e) {
        var d = e.data, j = jobs[d.id]; if (!j) return; delete jobs[d.id];
        if (d.error) { runOnPage(j); return; }
        var sub = function (o) {
          if (typeof o === 'string' && o.indexOf('@@') === 0) return 'url(' + URL.createObjectURL(d.blobs[+o.slice(2)]) + ')';
          if (Array.isArray(o)) return o.map(sub);
          if (o && typeof o === 'object') { var r = {}; for (var k in o) r[k] = sub(o[k]); return r; }
          return o;
        };
        j.done(sub(d.out));
      };
      worker.onerror = function () { worker = false; for (var id in jobs) { var j = jobs[id]; delete jobs[id]; runOnPage(j); } };
    } catch (err) { worker = false; }
    return worker;
  }
  function runOnPage(j) {
    var go = function () { idle(function () { j.done(computeJob(j.job)); }); };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }
  function runJob(job, done) {
    var w = getWorker(), j = { job: job, done: done };
    if (!w) { runOnPage(j); return; }
    job.id = ++jobSeq; jobs[job.id] = j; w.postMessage(job);
  }
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 60); })(fn, { timeout: 1500 }); }
  var started = { small: false, large: false, smallF: false, largeF: false, smallI: false, largeI: false, smallD: false, largeD: false };
  function whenTextures(el) {
    var key = (el.large ? 'large' : 'small') + (el.fluid ? 'F' : el.ink ? 'I' : el.drip ? 'D' : '');   /* 'F': liquid, 'I': ink pour, 'D': gouache drips */
    if (TEX[key]) { el.texture(); return; }
    waiting[key].push(el);
    if (!started[key]) { started[key] = true; buildTextures(key); }
  }

  /* ---------- watercolour: paper, graded wash, granulation (shared per page) ---------- */
  function vnoise(seed) {
    var R = rng(seed), G = 128, g = new Float32Array(G * G);
    for (var i = 0; i < G * G; i++) g[i] = R();
    return function (x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
      xf = xf * xf * (3 - 2 * xf); yf = yf * yf * (3 - 2 * yf);
      var a = g[((yi & 127) * G) + (xi & 127)], b = g[((yi & 127) * G) + ((xi + 1) & 127)],
          c = g[(((yi + 1) & 127) * G) + (xi & 127)], d = g[(((yi + 1) & 127) * G) + ((xi + 1) & 127)];
      return a + (b - a) * xf + (c - a) * yf + (a - b - c + d) * xf * yf;
    };
  }
  function boxBlur(src, w, h, r) {
    var t = new Float32Array(w * h), o = new Float32Array(w * h), x, y, s, k = 2 * r + 1;
    for (y = 0; y < h; y++) { s = 0; for (x = -r; x <= r; x++) s += src[y * w + Math.min(w - 1, Math.max(0, x))];
      for (x = 0; x < w; x++) { t[y * w + x] = s / k; s += src[y * w + Math.min(w - 1, x + r + 1)] - src[y * w + Math.max(0, x - r)]; } }
    for (x = 0; x < w; x++) { s = 0; for (y = -r; y <= r; y++) s += t[Math.min(h - 1, Math.max(0, y)) * w + x];
      for (y = 0; y < h; y++) { o[y * w + x] = s / k; s += t[Math.min(h - 1, y + r + 1) * w + x] - t[Math.max(0, y - r) * w + x]; } }
    return o;
  }
  /* hue (0-360) of a hex colour; interference hex codes are pale, so only the hue is used */
  function hexHue(h) {
    h = String(h || '').trim().replace('#', ''); if (h.length !== 6) return 200;
    var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn; if (d === 0) return 200;
    var hue = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
    return Math.round((hue * 60 + 360) % 360);
  }
  /* off-axis interference colour: the product's own hex (about as strong as the real
     colour shift), with a second stop nudged slightly round the colour wheel */
  function interferenceStops(el) {
    var h = String(el.style.getPropertyValue('--tsc-hex') || '').trim().replace('#', '');
    if (h.length !== 6) return;
    var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, s = 0, hue = 0;
    if (d) { s = d / (1 - Math.abs(2 * l - 1)); hue = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; hue = (hue * 60 + 360) % 360; }
    el.style.setProperty('--tsc-flip', '#' + h);
    el.style.setProperty('--tsc-flip2', 'hsl(' + Math.round((hue + 18) % 360) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)');
  }
  function makeWash(seed, S) {
    var sc = S / 400, N = S * S, n1 = vnoise(seed + 3), n2 = vnoise(seed + 11), n3 = vnoise(seed + 29), n4 = vnoise(seed + 47);
    var P = new Float32Array(N), IN = new Float32Array(N), TT = new Float32Array(N), RIM = new Float32Array(N), MOT = new Float32Array(N),
        DK = new Float32Array(N), BAR = new Uint8Array(N), x, y, i, x0 = .08 * S, x1 = .93 * S, topY = [], botY = [];
    for (x = 0; x < S; x++) { var u0 = x / sc, f = (x - x0) / (x1 - x0);
      topY.push((.13 + .03 * f) * S + (n2(u0 / 35, 1.1) - .5) * 10 * sc + (n1(u0 / 3, 2.2) - .5) * 2 * sc);
      botY.push((.85 - .02 * f) * S + (n3(u0 / 30, 3.3) - .5) * 12 * sc + (n1(u0 / 3, 4.4) - .5) * 2 * sc); }
    for (y = 0; y < S; y++) for (x = 0; x < S; x++) { i = y * S + x; var u = x / sc, v = y / sc;
      P[i] = n1(u / 2.1, v / 2.1) * .55 + n2(u / 4.3, v / 4.3) * .3 + n3(u / 9, v / 9) * .15;
      var edge = Math.min(x, y, S - 1 - x, S - 1 - y) / sc; DK[i] = Math.max(0, Math.min(1, (edge - 3 - n4(u / 3, v / 3) * 5) / 2.5));
      BAR[i] = (y > .43 * S && y < .57 * S && x > .04 * S && x < .96 * S) ? 1 : 0;
      MOT[i] = n3(u / 13, v / 13) * .6 + n4(u / 6, v / 6) * .4;
      var L = x0 + (n4(v / 22, 1.9) - .5) * 10 * sc + Math.pow(Math.abs((y - .49 * S) / (.38 * S)), 3) * 14 * sc;
      var Rr = x1 - (n2(v / 14, 6.1) - .35) * 30 * sc - (n1(u / 2, v / 2) - .5) * 8 * sc;
      var inside = (y > topY[x] && y < botY[x] && x > L && x < Rr) ? 1 : 0;
      if (inside && x > Rr - 26 * sc && n1(u / 1.4, v / 1.4) < .25 + ((x - (Rr - 26 * sc)) / (26 * sc)) * .5) inside = 0;
      IN[i] = inside; TT[i] = Math.max(0, Math.min(1, (x - x0) / (x1 - x0))); RIM[i] = inside ? Math.max(0, 1 - (x - L) / (9 * sc)) : 0; }
    IN = boxBlur(IN, S, S, Math.max(1, Math.round(1.3 * sc))); RIM = boxBlur(RIM, S, S, Math.max(1, Math.round(1.5 * sc)));
    var paperDark = new Uint8ClampedArray(N * 4), paper = new Uint8ClampedArray(N * 4), wash = new Uint8ClampedArray(N * 4), gran = new Uint8ClampedArray(N * 4),
        cover = new Uint8ClampedArray(N * 4), deck = new Uint8ClampedArray(N * 4);
    for (i = 0; i < N; i++) { var o = i * 4, sh = i > S ? (P[i - S - 1] - P[i]) * 95 : 0;
      paper[o] = 250 + sh; paper[o + 1] = 247 + sh; paper[o + 2] = 240 + sh; paper[o + 3] = 255;
      paperDark[o] = 30 + sh * .55; paperDark[o + 1] = 29 + sh * .55; paperDark[o + 2] = 28 + sh * .55; paperDark[o + 3] = 255;
      var d = 0;
      if (IN[i] > 0) { var db = 1 - .82 * Math.pow(TT[i], 1.05), tex = .18 + .7 * (1 - db);
        d = db * (1 + tex * ((1 - P[i]) - .45) * 1.6) + .12 * (MOT[i] - .5) + RIM[i] * .12; d = Math.max(0, Math.min(1, d * IN[i])); }
      wash[o + 3] = d * 255;
      gran[o + 3] = Math.min(255, Math.max(0, n4((i % S) / sc / 1.2, (i / S | 0) / sc / 1.2) - .52) * 2.2 * (1 - P[i]) * d * 2 * 255);
      cover[o + 3] = BAR[i] ? d * 255 : 0;
      deck[o] = deck[o + 1] = deck[o + 2] = 255; deck[o + 3] = DK[i] * 255; }
    return { paper: toURL(paper, S), paperDark: toURL(paperDark, S), wash: toURL(wash, S), gran: toURL(gran, S), cover: toURL(cover, S), deckle: toURL(deck, S) };
  }
  var WTEX = { small: null, large: null }, wWaiting = { small: [], large: [] }, wStarted = { small: false, large: false };
  function whenWash(el) {
    var size = el.large ? 'large' : 'small';
    if (WTEX[size]) { el.texture(); return; }
    wWaiting[size].push(el);
    if (!wStarted[size]) { wStarted[size] = true;
      runJob({ kind: 'wash', seed: size === 'large' ? 5 : 7, S: size === 'large' ? 640 : 360 }, function (out) {
        WTEX[size] = out.wash; if (!FLAKE) FLAKE = out.flake;
        wWaiting[size].splice(0).forEach(function (e) { e.texture(); });
      });
    }
  }
  /* paint the wash in once, the first time a watercolour card is on screen */
  var paintIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.inView = true; en.target.maybePaint(); paintIO.unobserve(en.target); } });
  }, { threshold: 0.35 }) : null;

  /* ---------- scroll-driven motion on touch devices ---------- */
  var visible = new Set(), ticking = false;
  function onScroll() { if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; visible.forEach(function (el) { el.scrollTilt(); }); }); }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
  }) : null;
  if (noHover && !reduce) addEventListener('scroll', onScroll, { passive: true });

  /* ---------- the element ---------- */
  var count = 0;
  class TaSwatchCard extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      this.idx = count++;
      this.large = this.getAttribute('size') === 'large';
      this.amp = this.large ? (noHover ? .9 : .6) : 1;  /* gentler tilt on the big product page card (desktop) */
      if (this.idx % 2) this.classList.add('tsc-flip');
      this.wc = this.getAttribute('data-style') === 'watercolour';
      if (this.wc) {
        this.classList.remove('tsc-flip');
        this.style.setProperty('--tsc-cover', { T: 0, ST: .14, SO: .3, O: .48 }[normOp(this.dataset.opacity)]);
        this.fx = this.getAttribute('data-wc-fx') || '';
        if (this.fx === 'interference') interferenceStops(this);
      }
      /* every card paints in once, the first time it is on screen */
      if (paintIO && !reduce) paintIO.observe(this); else this.inView = true;
      this.acfx = this.getAttribute('data-ac-fx') || '';
      if (this.acfx) this.classList.remove('tsc-flip');
      if (this.acfx === 'interference') {
        this.fx = 'interference';
        interferenceStops(this);
      }
      this.metal = this.hasAttribute('data-metallic');
      /* masstone: transparent paint deepens where it is thick; opaque paint barely changes */
      var dstr = { T: .95, ST: .7, SO: .38, O: .12 }[normOp(this.dataset.opacity)];
      if (this.acfx || this.metal || (this.getAttribute('data-style') === 'uvfx' && !this.hasAttribute('data-uv-plain'))) dstr = 0;
      this.style.setProperty('--tsc-depth', dstr == null ? .38 : dstr);
      var sh = this.metal ? SH.MET : SH[normSh(this.dataset.sheen)], st = this.style;
      st.setProperty('--tsc-thru', OP[normOp(this.dataset.opacity)]);
      st.setProperty('--tsc-spec', sh.spec); st.setProperty('--tsc-lr', sh.lr); st.setProperty('--tsc-shade', sh.shade); st.setProperty('--tsc-gl', sh.gl);
      this.sh = sh;
      this.s = { x: 0, y: 0, tx: 0, ty: 0, lx: 30, ly: 26, run: false, act: false };
      this.fluid = this.getAttribute('data-style') === 'liquid';   /* liquid acrylics: thinner, self-levelling paint */
      this.ink = this.getAttribute('data-style') === 'ink';        /* low viscosity: flat, ink-like pour */
      this.drip = this.getAttribute('data-style') === 'artnoise';  /* Art Noise gouache: matte drips from the top */
      this.uvScene = this.getAttribute('data-style') === 'uvfx' && !this.hasAttribute('data-uv-plain');
      if (this.getAttribute('data-style') === 'uvfx') this.fluid = true;   /* UVFX is a liquid acrylic */
      this.pop = this.getAttribute('data-style') === 'pop';
      if (this.pop) {
        this.classList.remove('tsc-flip');
        var hh = hexHue(this.style.getPropertyValue('--tsc-hex')), ch = (hh + 180) % 360;
        this.style.setProperty('--tsc-comp', 'hsl(' + ch + ' 70% 56%)');
        this.style.setProperty('--tsc-comp-lt', 'hsl(' + ch + ' 80% 84%)');
        this.classList.add('is-textured'); this.maybePaint();
      } else if (this.wc) whenWash(this); else whenTextures(this);
      if (reduce) return;
      this.tilt = this.querySelector('.tsc-tilt');
      this.frame = this.frame.bind(this);
      var self = this;
      var aim = function (e) {
        var r = self.getBoundingClientRect();
        self.s.tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
        self.s.ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
        self.s.act = true; self.classList.add('is-active', 'is-live'); self.kick();
      };
      /* mouse and pen: the card follows the pointer */
      this.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch') aim(e); });
      this.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') self.release(); });

      /* touch: press and hold briefly to pick the card up, then drag to steer it.
         A finger that starts moving straight away is a scroll (or, on the gallery card, a
         flick to the next slide), so the page never gets stuck under a card. Once the card
         is picked up, scrolling is held off until the finger lifts. */
      var T = null, HOLD = 180;
      this.addEventListener('touchstart', function (e) {
        if (self.large) e.stopPropagation();          /* keep the gallery carousel from dragging */
        if (e.touches.length !== 1) { T = null; return; }
        var t = e.touches[0];
        T = { x: t.clientX, y: t.clientY, t0: Date.now(), steer: false };
        T.timer = setTimeout(function () {
          if (!T) return;
          T.steer = true; self._touch = T; self.classList.add('is-steering');
          if (navigator.vibrate) { try { navigator.vibrate(8); } catch (err) {} }
          aim({ clientX: T.x, clientY: T.y });
        }, HOLD);
      }, { passive: true });
      this.addEventListener('touchmove', function (e) {
        if (!T) return;
        var t = e.touches[0];
        if (!T.steer) {
          if (Math.abs(t.clientX - T.x) + Math.abs(t.clientY - T.y) > 10) clearTimeout(T.timer);   /* scrolling: let it */
          return;
        }
        if (e.cancelable) e.preventDefault();          /* card is picked up: hold the page still */
        aim(t);
      }, { passive: false });
      var endTouch = function (e) {
        if (!T) return;
        clearTimeout(T.timer);
        var c = e.changedTouches && e.changedTouches[0];
        if (T.steer) {
          self._dragged = true; self._touch = null;
          self.classList.remove('is-steering'); self.release();
        } else if (self.large && c && e.type === 'touchend') {
          /* quick sideways flick on the gallery card: previous or next slide */
          var dx = c.clientX - T.x, dy = c.clientY - T.y;
          if (Date.now() - T.t0 < 400 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            var gal = self.closest('product-media') || document;
            var btn = gal.querySelector('flickity-controls [data-action="' + (dx < 0 ? 'next' : 'prev') + '"]');
            if (btn) btn.click();
          }
        }
        T = null;
      };
      this.addEventListener('touchend', endTouch);
      this.addEventListener('touchcancel', endTouch);
      if (this.large) this.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') e.stopPropagation(); });
      /* no long-press menu or image callout while steering, and a steer is not a tap */
      this.addEventListener('contextmenu', function (e) { if (T || self._touch) e.preventDefault(); });
      this.addEventListener('click', function (e) {
        if (self._dragged) { e.preventDefault(); e.stopPropagation(); self._dragged = false; }
      }, true);
      if (noHover && io) io.observe(this);
    }
    disconnectedCallback() { if (io) io.unobserve(this); if (paintIO) paintIO.unobserve(this); visible.delete(this); }
    maybePaint() { if (this.inView && this.classList.contains('is-textured')) this.classList.add('is-painted'); }
    texture() {
      if (this.wc) {
        var w = WTEX[this.large ? 'large' : 'small'], q = function (sel) { return this.querySelectorAll(sel); }.bind(this);
        var fx = this.fx;
        q('.tsc-wc-paper').forEach(function (e) { e.style.backgroundImage = fx ? w.paperDark : w.paper; });
        var fxl = this.querySelector('.tsc-wc-fx');
        if (fxl) { fxl.style.webkitMaskImage = fxl.style.maskImage = w.wash;
          if (!FLAKE) FLAKE = makeFlake(); this.querySelector('.tsc-wc-glint').style.backgroundImage = FLAKE; }
        var clip = this.querySelector('.tsc-clip--wc'); clip.style.webkitMaskImage = clip.style.maskImage = w.deckle;
        [['.tsc-wc-wash', w.wash], ['.tsc-wc-gran', w.gran], ['.tsc-wc-cover', w.cover]].forEach(function (p) {
          var e = this.querySelector(p[0]); e.style.webkitMaskImage = e.style.maskImage = p[1]; }, this);
        this.classList.add('is-textured'); this.maybePaint(); return;
      }
      var set = TEX[(this.large ? 'large' : 'small') + (this.fluid ? 'F' : this.ink ? 'I' : this.drip ? 'D' : '')], t = set[this.idx % set.length];
      var paint = this.querySelector('.tsc-paint');
      paint.style.webkitMaskImage = paint.style.maskImage = t.mask;
      this.querySelector('.tsc-shade').style.backgroundImage = t.shade;
      this.querySelector('.tsc-spec').style.backgroundImage = t[this.sh.tex];
      if (this.metal || this.acfx) this.querySelector('.tsc-flake').style.backgroundImage = FLAKE;
      var dp = this.querySelector('.tsc-depth'); if (dp && t.depth) dp.style.webkitMaskImage = dp.style.maskImage = t.depth;
      var cv = this.querySelector('.tsc-canvas'), CV = CANVAS[this.large ? 'large' : 'small'];
      if (cv && CV) cv.style.backgroundImage = (this.acfx || this.uvScene) ? CV.dark : CV.light;
      this.classList.add('is-textured'); this.maybePaint();
    }
    release() { this.s.tx = 0; this.s.ty = 0; this.s.act = false; this.classList.remove('is-active'); this.kick(); }
    scrollTilt() {
      if (this._touch) return;                       /* a finger is steering this card */
      var r = this.getBoundingClientRect(), vh = innerHeight, vw = innerWidth;
      var dy = ((r.top + r.height / 2) - vh / 2) / (vh / 2), dx = ((r.left + r.width / 2) - vw / 2) / (vw / 2);
      this.s.ty = Math.max(-1, Math.min(1, dy));
      this.s.tx = Math.max(-1, Math.min(1, dx * .7 + .15));
      /* the card nearest the middle of the screen counts as "active": blacklight on, lights on */
      this.classList.toggle('is-active', Math.abs(dy) < .32);
      this.classList.add('is-live'); this.kick();
    }
    kick() { if (!this.s.run) { this.s.run = true; requestAnimationFrame(this.frame); } }
    frame() {
      var boost = noHover ? 1.6 : 1;   /* phones and tablets: bigger tilt and parallax */
      var s = this.s, w = this.offsetWidth * this.amp * boost, st = this.tilt.style, c = this.style, a = this.amp * boost;
      s.x += (s.tx - s.x) * .12; s.y += (s.ty - s.y) * .12;
      var ltx = s.act ? 50 + s.tx * 50 : 30, lty = s.act ? 50 + s.ty * 50 : 26;
      if (noHover) { ltx = 50 + s.x * 60; lty = 50 + s.y * 60; }
      s.lx += (ltx - s.lx) * .14; s.ly += (lty - s.ly) * .14;
      st.setProperty('--tsc-ry', (s.x * 9 * a).toFixed(2) + 'deg'); st.setProperty('--tsc-rx', (-s.y * 9 * a).toFixed(2) + 'deg');
      st.setProperty('--tsc-tx', (s.x * w * .035).toFixed(1) + 'px'); st.setProperty('--tsc-ty', (s.y * w * .035).toFixed(1) + 'px');
      st.setProperty('--tsc-sx', (-s.x * w * .02).toFixed(1) + 'px'); st.setProperty('--tsc-sy', (-s.y * w * .02).toFixed(1) + 'px');
      var lift = Math.min(1, Math.abs(s.x) + Math.abs(s.y));
      st.setProperty('--tsc-sox', (5 + lift * 8).toFixed(1) + 'px'); st.setProperty('--tsc-soy', (8 + lift * 12).toFixed(1) + 'px');
      st.setProperty('--tsc-so', (.24 + lift * .12).toFixed(3));
      c.setProperty('--tsc-lx', (this.classList.contains('tsc-flip') ? 100 - s.lx : s.lx).toFixed(1) + '%'); c.setProperty('--tsc-ly', s.ly.toFixed(1) + '%');
      /* reflection band and flake glints follow the light */
      var bx = this.classList.contains('tsc-flip') ? s.lx : 100 - s.lx;
      c.setProperty('--tsc-bpx', (bx * .9 + 5).toFixed(1) + '%'); c.setProperty('--tsc-bpy', (100 - s.ly * .9 - 5).toFixed(1) + '%');
      if (this.fx) {
        c.setProperty('--tsc-flipo', (.14 + .86 * Math.min(1, lift * 1.3)).toFixed(3));
        c.setProperty('--tsc-fx', (s.x * 7).toFixed(1) + 'px'); c.setProperty('--tsc-fy', (s.y * 7).toFixed(1) + 'px');
      }
      if (this.metal) { c.setProperty('--tsc-fx', (s.x * 7).toFixed(1) + 'px'); c.setProperty('--tsc-fy', (s.y * 7).toFixed(1) + 'px'); }
      var moving = Math.abs(s.tx - s.x) + Math.abs(s.ty - s.y) > .002 || Math.abs(ltx - s.lx) + Math.abs(lty - s.ly) > .1;
      if (moving || s.act) requestAnimationFrame(this.frame);
      else { s.run = false; if (!noHover) this.classList.remove('is-live'); }
    }
  }
  customElements.define('ta-swatch-card', TaSwatchCard);
})();